import React from 'react';
import './LandingCard.css';

function LandingCard({
    children,
    className = '',
    hover = true,
    ...props
}) {
    return (
        <div
            className={`ovicatalogos-card ${hover ? 'ovicatalogos-card-hover' : ''} ${className}`}
            {...props}
        >
            {children}
        </div>
    );
}

function LandingCardContent({ children, className = '' }) {
    return (
        <div className={`ovicatalogos-card-content ${className}`}>
            {children}
        </div>
    );
}

LandingCard.Content = LandingCardContent;

export default LandingCard;
export { LandingCardContent };
